module.exports = __webpack_public_path__ + "img/speaker-01.a1af7307.svg";